// Filter chip render helpers (lint split from FilterBar.jsx).
import { Box } from '@mui/material';
import TagChip from '@/components/ui/TagChip';
import { toggleFilterById } from '@/components/layout/filterBarUtils';

export function renderProjectFilterChip({
  option,
  chipIndex,
  selectedProjects,
  setProjectFilter,
  getTabIndex,
}) {
  const { id, label, count } = option;
  const index = chipIndex.current;
  chipIndex.current += 1;
  return (
    <TagChip
      key={label}
      tag={id}
      label={`#${label}`}
      labelSuffix={` (${count})`}
      aria-label={`#${label} (${count})`}
      selectable
      selected={selectedProjects.has(id.toLowerCase())}
      onClick={() => toggleFilterById(id, selectedProjects, setProjectFilter)}
      tabIndex={getTabIndex(index)}
    />
  );
}

export function renderContextFilterChip({
  option,
  chipIndex,
  selectedContexts,
  setContextFilter,
  getTabIndex,
}) {
  const { id, label, count } = option;
  const index = chipIndex.current;
  chipIndex.current += 1;
  return (
    <TagChip
      key={label}
      tag={`@${id}`}
      label={label}
      labelSuffix={` (${count})`}
      aria-label={`@${label} (${count})`}
      selectable
      selected={selectedContexts.has(id.toLowerCase())}
      onClick={() => toggleFilterById(id, selectedContexts, setContextFilter)}
      tabIndex={getTabIndex(index)}
    />
  );
}

export function renderFilterBarTagDivider() {
  return (
    <Box
      data-testid="filterbar-tag-divider"
      sx={{
        width: '1px',
        alignSelf: 'stretch',
        minHeight: 16,
        bgcolor: 'divider',
        mx: 0.25,
      }}
    />
  );
}
